import { memo, PropsWithChildren, ReactElement, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export interface BaseFilterChipProps extends PropsWithChildren {
  icon?: ReactNode;
  onRemove: () => void;
}

export const BaseFilterChip = memo(function ({ icon, children, onRemove }: BaseFilterChipProps): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid',
        borderRadius: '0.5rem',
        gap: '0.5em',
      }}
    >
      <Typography variant='body2' sx={{ ml: 1 }}>
        {children}
      </Typography>
      {icon}
      <IconButton onClick={onRemove} size='small'>
        <CloseIcon />
      </IconButton>
    </Box>
  );
});
